import { selectAuthMfaError } from '@/features/auth/selectors';
import { LIMIT_EXCEEDED, NO_DEVICE_FOUND } from '@/features/mfa/constants';
import { parseVenueIds } from '@/utils/venueUtils';

import { createSelector } from '@reduxjs/toolkit';
import { complement, either, head, isEmpty, isNil, pipe, prop, propOr } from 'ramda';
const hasValue = complement(either(isEmpty, isNil));

export const selectUser = (state) => state.user;
export const selectUserId = createSelector(selectUser, prop('id'));
export const selectUsername = createSelector(selectUser, prop('type'));
export const selectSessionToken = createSelector(selectUser, prop('session_token'));
export const selectIsSuperAdmin = createSelector(selectUser, prop('super_admin'));
export const selectVenueIds = createSelector(
  selectUser,
  pipe(propOr('[]', 'venue_ids'), parseVenueIds)
);
export const selectOrganizationId = createSelector(selectUser, prop('organization_id'));
export const selectUserEmail = createSelector(selectUser, prop('email'));
export const selectUserError = createSelector(selectUser, prop('error'));
export const selectFirstVenueId = createSelector(selectVenueIds, head);
export const selectHasSessionToken = createSelector(selectSessionToken, complement(isNil));
export const selectHasVenueIds = createSelector(selectVenueIds, hasValue);
export const selectHasUserId = createSelector(selectUserId, hasValue);
export const selectIsLoggedIn = createSelector(
  selectHasSessionToken,
  selectHasUserId,
  (hasSessionToken, hasUserId) => hasSessionToken && hasUserId
);

export const selectNoUsableDevicesError = createSelector(
  [selectUserError, selectAuthMfaError],
  (userError, authError) => {
    if (!userError && !authError) return null;
    const errMsg = authError?.message || userError?.message;
    if (errMsg.startsWith(LIMIT_EXCEEDED)) {
      return LIMIT_EXCEEDED;
    }
    if (errMsg.startsWith(NO_DEVICE_FOUND)) {
      return NO_DEVICE_FOUND;
    }
    return null;
  }
);
